// extracted by mini-css-extract-plugin
export var form_row = "index-module--form_row--svchz";
export var form_wrapper = "index-module--form_wrapper--1QLtX";